/* New Comfort · homepage 2026 */
(function(){
  if(window.__nchHome) return; window.__nchHome=true;
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mq=window.matchMedia&&matchMedia('(max-width: 760px)');
    function heroVideo(){
      if(reduce) return;
      var mob=mq&&mq.matches;
      var on=document.querySelector(mob?'.nch-hero__media .v-mob':'.nch-hero__media .v-desk');
      var off=document.querySelector(mob?'.nch-hero__media .v-desk':'.nch-hero__media .v-mob');
      if(off&&!off.paused) off.pause();
      if(!on) return;
      if(!on.getAttribute('src')&&on.getAttribute('data-src')){ on.src=on.getAttribute('data-src'); on.autoplay=true; }
      var p=on.play(); if(p&&p.catch)p.catch(function(){});
    }
    heroVideo();
    if(mq){ if(mq.addEventListener) mq.addEventListener('change',heroVideo); else if(mq.addListener) mq.addListener(heroVideo); }
    // Chrome pauses muted autoplay off-screen and does not always resume: play only while visible
    if(!reduce&&'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){
          var v=e.target; if(!v.getAttribute('src')) return;
          if(e.isIntersecting){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); } else if(!v.paused) v.pause();
        });
      },{threshold:.15});
      [].forEach.call(document.querySelectorAll('.nch-hero__media video'),function(v){ io.observe(v); });
    }
    // measure the sticky theme header so the day timeline's sticky frame can stop right below it
    function hdrHeight(){
      var h=0;
      [].forEach.call(document.querySelectorAll('.shopify-section-group-header-group,sticky-header,.section-header,header'),function(e){
        var cs=getComputedStyle(e);
        if((cs.position==='sticky'||cs.position==='fixed')&&e.offsetHeight>h) h=e.offsetHeight;
      });
      return h;
    }
    function setHdr(){ document.documentElement.style.setProperty('--nch-hdr',hdrHeight()+'px'); }
    setHdr();
    addEventListener('resize',setHdr,{passive:true});
    addEventListener('load',setHdr);
    // zones photo: start the slow left-to-right drift once the frame is in view (CSS .is-live)
    var stage=document.querySelector('.nch-pk2__stage');
    if(stage&&'IntersectionObserver' in window){
      var sio=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ stage.classList.add('is-live'); sio.disconnect(); } }); },{threshold:.35});
      sio.observe(stage);
    }
    // the italic part of every title writes itself in, letter by letter (full text kept for screen readers)
    var titles=[].slice.call(document.querySelectorAll('.nch h1, .nch h2, .nch-vm h3')).filter(function(h){ return h.querySelector('em'); });
    if(!reduce&&titles.length&&'IntersectionObserver' in window){
      var split=function(h){
        var n=0, ems=[].slice.call(h.querySelectorAll('em'));
        var len=ems.reduce(function(s,e){ return s+e.textContent.replace(/\s+/g,'').length; },0);
        ems.forEach(function(em){
        var sr=document.createElement('span'); sr.className='nch-sr'; sr.textContent=em.textContent.replace(/\s+/g,' ').trim();
        (function walk(node){
          [].slice.call(node.childNodes).forEach(function(c){
            if(c.nodeType===3){
              var frag=document.createDocumentFragment();
              c.textContent.split(/(\s+)/).forEach(function(w){
                if(!w) return;
                if(/^\s+$/.test(w)){ frag.appendChild(document.createTextNode(w)); return; }
                var ws=document.createElement('span'); ws.className='nch-w'; ws.setAttribute('aria-hidden','true');
                Array.from(w).forEach(function(ch){ var l=document.createElement('span'); l.className='nch-l'; l.style.setProperty('--i',n++); l.textContent=ch; ws.appendChild(l); });
                frag.appendChild(ws);
              });
              node.replaceChild(frag,c);
            } else if(c.nodeType===1&&c.tagName!=='BR') walk(c);
          });
        })(em);
        em.insertBefore(sr,em.firstChild);
        });
        h.style.setProperty('--d',Math.max(30,Math.min(55,Math.round(1500/Math.max(len,1))))+'ms'); // long italic parts finish in ~1.5–2 s
        h.classList.add('nch-type');
      };
      titles.forEach(split);
      var day=document.querySelector('.nch-day');
      var dayTitles=day&&window.CSS&&CSS.supports('animation-timeline: view()')?[].slice.call(day.querySelectorAll('.nch-day__line h2')):[];
      var tio=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); tio.unobserve(e.target); } });
      },{rootMargin:'0px 0px -18% 0px'});
      titles.forEach(function(h){ if(dayTitles.indexOf(h)<0) tio.observe(h); });
      // day timeline: the moments are stacked in one sticky frame → follow the scroll progress (same ranges as the CSS)
      if(dayTitles.length===4){
        var R=[[-999,30],[23,55],[48,80],[73,999]], tick=false;
        var upd=function(){
          tick=false;
          var r=day.getBoundingClientRect(), seen=r.bottom>0&&r.top<innerHeight;
          var p=(-r.top)/Math.max(1,r.height-innerHeight)*100;
          dayTitles.forEach(function(h,i){
            var on=seen&&p>=R[i][0]+4&&p<=R[i][1]-4, off=!seen||p<R[i][0]||p>R[i][1];
            if(on&&!h.classList.contains('is-in')){ h.classList.remove('is-out'); h.classList.add('is-in'); }
            else if(off&&h.classList.contains('is-in')){ h.classList.add('is-out'); h.classList.remove('is-in'); }
          });
        };
        addEventListener('scroll',function(){ if(!tick){ tick=true; requestAnimationFrame(upd); } },{passive:true});
        addEventListener('resize',upd); upd();
      }
    }
    var tabs=[].slice.call(document.querySelectorAll('.nch-pk2__tab'));
    function select(t){
      tabs.forEach(function(x){
        var on=x===t; x.setAttribute('aria-selected',on?'true':'false'); x.tabIndex=on?0:-1;
        var pn=document.getElementById(x.getAttribute('aria-controls')); if(pn) pn.hidden=!on;
        var im=document.querySelector('.nch-pk2__stage img[data-k="'+x.id.slice(2)+'"]'); if(im) im.classList.toggle('is-on',on);
      });
    }
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(){select(t);});
      t.addEventListener('keydown',function(e){
        var n=null;
        if(e.key==='ArrowRight'||e.key==='ArrowDown') n=tabs[(i+1)%tabs.length];
        if(e.key==='ArrowLeft'||e.key==='ArrowUp') n=tabs[(i-1+tabs.length)%tabs.length];
        if(n){e.preventDefault();select(n);n.focus();}
      });
    });
    var dlg=document.getElementById('film-dlg'), fv=document.getElementById('film-v'), op=document.getElementById('film-open'), cl=document.getElementById('film-close');
    if(dlg&&op){
      op.addEventListener('click',function(){ if(dlg.showModal) dlg.showModal(); else dlg.setAttribute('open',''); if(fv){var p=fv.play(); if(p&&p.catch)p.catch(function(){});} });
      if(cl) cl.addEventListener('click',function(){ dlg.close(); });
      dlg.addEventListener('close',function(){ if(fv) fv.pause(); });
      dlg.addEventListener('click',function(e){ if(e.target===dlg) dlg.close(); });
    }
  });
})();
